import { render } from "./AddCleTypeNotificationModal.vue?vue&type=template&id=4e10f39b&ts=true"
import script from "./AddCleTypeNotificationModal.vue?vue&type=script&lang=ts"
export * from "./AddCleTypeNotificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__